import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';

const getClientDocumentTypes = async () => {
  return await request.get(
    '/HousingStock/client/documents/types',
    {},
    'При загрузке типов документов произошла ошибка',
    []
  );
};

const useClientDocumentTypes = (options = {}) => {
  return useQuery(
    getQueryKeys.clientDocumentTypes(),
    () => getClientDocumentTypes(),
    options
  );
};

export default useClientDocumentTypes;
